import { useQueryClient } from "react-query";
import { useSmartMutation } from "./useSmartMutation";
import { setPreferences } from "../apis/ext";

export const useSetPreferences = (onSuccess, onError) => {
  const queryClient = useQueryClient();

  return useSmartMutation("set_pref", setPreferences, {
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries("get_user");
      onSuccess?.(data, variables, context);
    },
    onError,
  });
};
